const updates = [
  {
    date: '07-28',
    title: '《霸道总裁的契约新娘》第128话更新',
    tag: '韩漫·恋爱',
    type: 'update',
  },
  {
    date: '07-28',
    title: '《剑与魔法的异世界》第203话更新',
    tag: '日漫·热血',
    type: 'update',
  },
  {
    date: '07-27',
    title: '新作上架：《修仙大佬在现代》全集上线',
    tag: '国漫·奇幻',
    type: 'new',
  },
  {
    date: '07-27',
    title: '《我们的青春物语》第89话更新',
    tag: '日漫·校园',
    type: 'update',
  },
  {
    date: '07-26',
    title: '热门推荐：本月韩漫恋爱榜单发布',
    tag: '韩漫·盘点',
    type: 'hot',
  },
  {
    date: '07-26',
    title: '《暗夜追踪者》第56话更新',
    tag: '韩漫·悬疑',
    type: 'update',
  },
  {
    date: '07-25',
    title: '平台公告：移动端阅读体验全面升级',
    tag: '平台·公告',
    type: 'notice',
  },
  {
    date: '07-25',
    title: '新作上架：《古风奇谭之画中仙》第一章',
    tag: '国漫·古风',
    type: 'new',
  },
];

const typeStyles: Record<string, { icon: string; bg: string }> = {
  update: { icon: 'ri-refresh-line', bg: 'bg-primary-100 text-primary-600' },
  new: { icon: 'ri-sparkling-line', bg: 'bg-accent-100 text-accent-600' },
  hot: { icon: 'ri-fire-line', bg: 'bg-accent-100 text-accent-600' },
  notice: { icon: 'ri-notification-3-line', bg: 'bg-secondary-200/80 text-secondary-700' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            更新动态
          </h2>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            全部动态 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="relative pl-8 border-l-2 border-background-200/70 space-y-6">
          {updates.map((item, i) => {
            const style = typeStyles[item.type] || typeStyles.update;
            return (
              <div key={i} className="relative">
                <div className={`absolute -left-[calc(2rem+5px)] w-3 h-3 rounded-full border-2 border-background-50 ${item.type === 'hot' ? 'bg-accent-500' : item.type === 'new' ? 'bg-primary-500' : 'bg-secondary-400'}`}></div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.bg}`}>
                    <i className={`${style.icon} text-[10px]`}></i>
                    {item.tag}
                  </span>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="text-sm text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer line-clamp-1"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}